
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type SearchByVehicleDialogButtonRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function SearchByVehicleDialogButtonRT(): TemplateResult<SearchByVehicleDialogButtonRTRootProps> {
    return _createElement('div', { 'className': 'header-search-by-vehicle-wrapper' }, [this.changeButton(function () {
            return _createElement('div', { 'className': 'cm_changeButton' }, _createElement('button', {
                'type': 'button',
                'className': 'cm_search-by-vehicle-dialog-button header-search-by-vehicle'
            }, _createElement('span', { 'className': 'cm_search-by-vehicle-dialog__icon svg-wrapper header-search-by-vehicle__icon' }, [_createElement('svg', {
                    'xmlns': 'http://www.w3.org/2000/svg',
                    'viewBox': '0 0 24 24',
                    'fill': 'currentColor',
                    'aria-hidden': 'true',
                    'key': '2310'
                }, _createElement('path', { 'd': 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z' }))]), this.template === 'active' ? _createElement('div', {
                'className': 'cm_search-by-vehicle-dialog__text cmTemplate_active',
                'key': '738'
            }, 'SEARCH BY VEHICLE') : null, this.template === 'locked' ? _createElement('div', {
                'className': 'cm_search-by-vehicle-dialog__text cmTemplate_locked',
                'key': '878'
            }, this.vehicleString) : null, _createElement('span', { 'className': 'cm_search-by-vehicle-dialog__caret svg-wrapper header-search-by-vehicle__caret' }, [_createElement('svg', {
                    'width': '14',
                    'height': '14',
                    'viewBox': '0 0 14 14',
                    'fill': 'none',
                    'xmlns': 'http://www.w3.org/2000/svg',
                    'key': '11230'
                }, _createElement('path', {
                    'd': 'M11 5.5L7 9.5L3 5.5',
                    'stroke': 'currentColor',
                    'strokeWidth': 'var(--icon-stroke-width)',
                    'strokeLinecap': 'round',
                    'strokeLinejoin': 'round'
                }))])));
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:changeButton"]